module.exports = __webpack_public_path__ + "img/virus.ec82a922.svg";